import { defineMessages } from 'react-intl';

const primitiveMessages = defineMessages({
    backButtonText: {
        id: 'primitive.primitiveMessages.backButtonText',
        description: 'Back button text',
        defaultMessage: 'Back'
    },
    backButtonAriaText: {
        id: 'primitive.primitiveMessages.backButtonAriaText',
        description: 'Back button text',
        defaultMessage: 'Back to product page'
    },
    productBackButtonAriaText: {
        id: 'primitive.primitiveMessages.productBackButtonAriaText',
        description: 'Back button text',
        defaultMessage: 'Back to home'
    },
    paymentBackButtonAriaText: {
        id: 'primitive.primitiveMessages.paymentBackButtonAriaText',
        description: 'Back button text',
        defaultMessage: 'Back to cart'
    }

});

export default primitiveMessages;
